import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Box,
  Typography,
  IconButton,
  Button,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";

const IncompleteOrdersDialog = ({
  open,
  onClose,
  onProceed,
  incompleteOrders = [],
  t,
  isCompleting = false,
}) => {

  return (
    <Dialog
      open={open}
      onClose={isCompleting ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
          color: "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 2,
          px: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <WarningIcon sx={{ fontSize: "1.5rem" }} />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              fontSize: "1.1rem",
            }}
          >
            {t("Console.IncompleteOrdersDialog.Title", {
              defaultValue: "Incomplete Orders",
            })}
          </Typography>
        </Box>
        {!isCompleting && (
          <IconButton
            size="small"
            onClick={onClose}
            sx={{
              color: "#ffffff",
              "&:hover": { color: "#e0e7ff", backgroundColor: "rgba(255, 255, 255, 0.1)" },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent
        sx={{
          px: 3,
          pt: 3,
          pb: 2,
          backgroundColor: "#f8fafc",
        }}
      >
        <DialogContentText
          sx={{
            color: "#475569",
            fontSize: "0.95rem",
            lineHeight: 1.7,
            mb: 2,
          }}
        >
          {t("Console.IncompleteOrdersDialog.Message", {
            defaultValue: "You have incomplete tasks for some orders. Do you want to proceed, or work on those orders now?",
          })}
        </DialogContentText>

        {incompleteOrders.length > 0 && (
          <Box
            sx={{
              backgroundColor: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: 2,
              p: 2,
              mt: 2,
            }}
          >
            <Typography
              sx={{
                color: "#1e293b",
                fontSize: "0.875rem",
                fontWeight: 600,
                mb: 1.5,
              }}
            >
              {t("Console.IncompleteOrdersDialog.IncompleteOrdersLabel", {
                defaultValue: "Incomplete Orders:",
              })}
            </Typography>
            <Typography
              sx={{
                fontFamily: "monospace",
                fontWeight: 600,
                color: "#1e293b",
                fontSize: "0.875rem",
                lineHeight: 1.6,
                wordBreak: "break-word",
              }}
            >
              {incompleteOrders
                .map((order) => {
                  const storageLocation = order.storage_location || order.storageLocation;
                  return (storageLocation && storageLocation.trim() !== "" && storageLocation !== "null" && storageLocation !== "undefined")
                    ? storageLocation
                    : `Order ${order.id || ""}`;
                })
                .join(", ")}
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          py: 2.5,
          backgroundColor: "#f8fafc",
          borderTop: "1px solid #e2e8f0",
        }}
      >
        <Button
          onClick={onClose}
          disabled={isCompleting}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            color: "#64748b",
            px: 3,
            "&:hover": {
              backgroundColor: "#e2e8f0",
            },
          }}
        >
          {t("Console.IncompleteOrdersDialog.Cancel", {
            defaultValue: "Cancel",
          })}
        </Button>
        <Button
          onClick={onProceed}
          disabled={isCompleting}
          variant="contained"
          startIcon={isCompleting ? <CircularProgress size={16} color="inherit" /> : null}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
            boxShadow: "0 8px 18px rgba(124, 58, 237, 0.35)",
            px: 3,
            "&:hover": {
              background: "linear-gradient(135deg, #6d28d9 0%, #5b21b6 100%)",
            },
            "&:disabled": {
              background: "#cbd5e1",
              boxShadow: "none",
            },
          }}
        >
          {isCompleting
            ? t("Console.IncompleteOrdersDialog.Proceeding", {
                defaultValue: "Proceeding...",
              })
            : t("Console.IncompleteOrdersDialog.Proceed", {
                defaultValue: "Proceed",
              })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

IncompleteOrdersDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
  incompleteOrders: PropTypes.array,
  t: PropTypes.func.isRequired,
  isCompleting: PropTypes.bool,
};

IncompleteOrdersDialog.defaultProps = {
  incompleteOrders: [],
  isCompleting: false,
};

export default IncompleteOrdersDialog;




// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/counter/dialogs/IncompleteOrdersDialog.jsx